import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isIdpLoginReady } from '~/common/helpers/identityProvider/isIdpLoginReady';
import withHooks from '~/common/hoc/withHooks';
import { StoreDispatcher } from '~/scenes/Governance/types/StoreDispatcher';
import { StoreRootState } from '~/scenes/Governance/types/StoreRootState';

export type Props = {
  buttonLoading: boolean;
  idpLoginUrl: string;
  clearSession: () => void;
};

const enhancer = withHooks(() => {
  const [buttonReady, setButtonReady] = useState<boolean>(false);
  const { redirectUrl, hasCustomerIdentityProvider } = useSelector(
    ({ authentication }: StoreRootState) => ({
      redirectUrl: authentication.realmParams?.redirectUrl,
      hasCustomerIdentityProvider:
        authentication.realmParams?.hasCustomerIdentityProvider
    })
  );
  const { realm } = useSelector(({ application }: StoreRootState) => ({
    realm: application.subdomain
  }));
  const dispatch = useDispatch<StoreDispatcher>();

  useEffect(() => {
    if (!redirectUrl) {
      dispatch.authentication.getNotLoggedPlatformParameter({
        realm,
        param: 'hasCustomerIdentityProvider'
      });
    }
  }, []);

  useEffect(() => {
    setButtonReady(isIdpLoginReady(hasCustomerIdentityProvider, redirectUrl));
  }, [hasCustomerIdentityProvider, redirectUrl]);

  return {
    buttonLoading: !buttonReady,
    idpLoginUrl: redirectUrl,
    clearSession: () => dispatch.authentication.reset()
  } as Props;
});

export default enhancer;
